import Promise from 'promise-polyfill';

function loadScript(url, useDefer = false, useAsync = false) {
	if (document.querySelector(`script[src="${url}"]`)) {
		return Promise.resolve();
	}
	/* Wire up response promise */
	let resolveCB;
	const resultPromise = new Promise((resolve, reject) => {
		resolveCB = resolve;
	});
	/* Create tag and append to the body */
	const scriptTag = document.createElement('script');
	scriptTag.src = url;
	scriptTag.onload = resolveCB;
	if (useDefer) { scriptTag.defer = useDefer; }
	if (useAsync) { scriptTag.async = useAsync; }
	document.body.appendChild(scriptTag);
	return resultPromise;
}

export default loadScript;
